import styled from 'styled-components';

import {buttonReset, colors} from '@app/styles/theme';

export const AccountInfo = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex: 1;
`;

export const ProfileButton = styled.div`
    ${buttonReset};

    font-weight: 500;
    font-size: 12px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;

    &:hover {
        text-decoration: underline;
    }

    > :first-of-type {
        margin-right: 10px;
    }
`;

export const Separator = styled.div`
    margin: 0 13px;
    width: 1px;
    height: 20px;
    background-color: ${colors.border};
`;

export const LeaveButton = styled.div`
    ${buttonReset};

    font-weight: 500;
    font-size: 12px;
    cursor: pointer;
    color: ${colors.brandPrimary};

    &:hover {
        text-decoration: underline;
    }
`;

export const UserInfo = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const SubInfo = styled.div`
    font-size: 10px;
    color: ${colors.textSecondary};
`;
